import $ from 'domtastic'
import gsap from 'gsap'
import SplitText from '@js/vendors/gsap/SplitText.min'

import { unwrapLine } from '@utils/utils'




/* AUTO WOOSH ON SCROLL
---------------------------------------------------------------------------------------------------- */

export default class Woosh {

    constructor($ctn) {
        this.$ctn = $ctn
        this.splitTexts = getsplitTexts(this.$ctn.find('[data-split]:not(.visually-hidden):not(.sr-only)'))


        document.addEventListener('contentChange', () => {
            setTimeout(() => {
                this.scrollTriggers.forEach((st) => {
                    st.scrollTrigger.refresh()
                })
            }, 200)
        })
    }


    init() {
        this.initScrollReveal()
    }




    /* Actions
    --------------------------------------------------------- */

    splitText() {
        this.splitTexts.forEach((t) => {
            if (t.displayed) return

            clearSplitText(t.$el[0], this.splitTexts)

            const charsType = APP.Layout.isMobile ? 'words, chars' : 'lines, chars'
            const type = t.$el[0].dataset.split === 'lines' ? 'lines' : charsType

            t.split = new SplitText(t.$el, { type, charsClass: 'splitChar', linesClass: 'splitLine' })
            // t.split.chars.forEach((l) => { wrap(l, $('<span class="split-charCtn">')[0]) })

            t.$el.addClass('is-ready')
        })
    }


    initScrollReveal() {
        if (APP.Browser.reducedMotion) return

        const animKeys = Object.keys(animationLibrary)
        const selector = animKeys
            .map(k => `[data-${k}]:not([data-st]):not(.visually-hidden):not(.sr-only)`)
            .join(',')


        this.scrollTriggers = this.$ctn.find('[data-st]').map((trigger) => {
            const { dataset: config } = trigger
            const $children = Object.keys(config).some(e => animKeys.includes(e))
                ? [trigger]
                : [...trigger.querySelectorAll(selector)]

            const startString = config.st || 'top bottom'
            const start = Number.isNaN(parseInt(startString, 10)) ? startString : parseInt(startString, 10)

            const tl = gsap.timeline({
                default: {
                    ease: 'none',
                    force3D: true,
                },
                scrollTrigger: {
                    trigger,
                    start,
                    end: config.stEnd || 'bottom top',
                    scrub: 0.4,

                    onToggle: ({ isActive }) => {
                        const shouldWillChange = isActive && !config.preventStacking
                        gsap.set($children, { willChange: shouldWillChange ? 'transform' : '' })
                    },
                },
            })


            $children.forEach(($el) => {
                tl.add(animationLibrary.plx($el, this.splitTexts), 0)
            })

            return tl
        })
    }

}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */

const clearSplitText = ($el, splitRefs = []) => {
    const st = splitRefs.find(e => e.$el.get(0) === $el)

    if (!st || !st.split.chars) return

    st.split.chars.forEach((c) => { unwrapLine(c) })
    st.split.revert()
}

const getsplitTexts = sel => Array.from(sel).map(title => ({
    $el   : $(title),
    split : {},
    displayed: false,
}))


const animationLibrary = {
    plx: $el => gsap.fromTo($el,
        { ...JSON.parse($el.dataset?.plxFrom || '{}') },
        { ...JSON.parse($el.dataset.plx), ease: 'none' }),

    // appear: ($el, stRef) => {
    //     const { isMobile } = APP.Layout
    //     const ST = stRef ? stRef.find(e => e.$el.get(0) === $el) : null
    //     const tl = gsap.timeline({
    //         defaults: {
    //             force3D     : true,
    //             duration    : 0.8,
    //             ease        : 'power3.out',
    //             willChange  : 'transform, opacity',
    //             stagger     : { amount: 0.3 },
    //         },
    //         onComplete: () => {
    //             const clr = [$el]

    //             if (ST) {
    //                 ST.displayed = true
    //                 // clr.push([...ST.split.chars, ...ST.split.lines])
    //             }

    //             gsap.set(clr, { clearProps : 'opacity,transform,willChange,transformOrigin' })
    //         },
    //     })

    //     if (ST && ST.split.lines) {
    //         const { chars, lines } = ST.split
    //         const offY = isMobile ? 20 : 50

    //         if (chars.length) {
    //             tl.set(chars, { transformPerspective: 1000 })
    //             tl.from(chars, { alpha: 0, duration: 0.7 }, 0)
    //             if (!isMobile) tl.from(chars, { rotateX: -90, y: 80, z: -80 }, 0)
    //             if (isMobile) tl.from(chars, { rotateX: -90, y: 40, z: -40 }, 0)
    //         }

    //         if (lines.length > 1) tl.from(lines, { alpha: 0, y: offY }, 0)
    //     } else if (!$el.dataset.appear.length) {
    //         if (!isMobile) {
    //             tl.set($el, { transformPerspective: 1000 })
    //         }

    //         tl.from($el, { alpha: 0, duration: 0.7, delay: 0.01 }, 0)
    //         if (!isMobile) tl.from($el, { rotateX: -20, y: 200, z: 50 }, 0)
    //         if (isMobile) tl.from($el, { y: 50 }, 0)
    //     } else {
    //         tl.from($el,
    //             // { ...JSON.parse($el.dataset?.appearFrom || '{}') },
    //             { ...JSON.parse($el.dataset.appear) },
    //             0)
    //     }


    //     return tl
    // },
}



